import React, { useMemo } from 'react'
import { map, isEmpty, mapValues, size, without } from 'lodash'
import moment from 'moment'

const buildFacetAttribute = (values, name) => {
  if (isEmpty(values)) return ''
  switch (name) {
    case 'archived':
      return values ? `${name}:${values}` : `NOT ${name}:true`
    default:
      return map(values, (value) => `${name}:"${value}"`).join(' AND ')
  }
}

export const useFacetsBuildQuery = (facetsState) => {
  const searchFilters = useMemo(() => {
    const filterState = facetsState //pick(facetsState, filterProps);
    if (!size(filterState)) return

    let queries = map(filterState, (value, propName) => {
      switch (propName) {
        case 'created_at': {
          const { startDate, endDate } = mapValues(value, (v) =>
            moment(v).unix()
          )
          return startDate && endDate
            ? `${propName}: ${startDate} TO ${endDate}`
            : ''
        }
        default:
          return buildFacetAttribute(value, propName)
      }
    })
    queries = without(queries, '').join(' AND ')

    if (!isEmpty(queries)) return queries
  }, [facetsState])

  return {
    searchFilters,
  }
}
